import SectionHead from "./SectionHead";
import { flashFeed } from "@/mocks/cgua";

export default function FlashFeed() {
  return (
    <section id="huizong" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* 汇总快讯 高密度 */}
          <div className="lg:col-span-8">
            <SectionHead
              no="04"
              eyebrow="17吃瓜汇总"
              title="滚动快讯 · 一条不落"
              desc="按时间倒序的短讯流，只留最要紧的一句话与出处，方便上班/摸鱼两不误地补进度。"
              linkLabel="更多快讯"
            />
            <ul className="rounded-xl border border-background-200 bg-background-50 overflow-hidden divide-y divide-background-100">
              {flashFeed.map((f, i) => (
                <li key={i}>
                  <a
                    href="#"
                    className="flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3 hover:bg-background-100 transition-colors group cursor-pointer"
                  >
                    <span className="w-11 shrink-0 text-xs font-mono text-foreground-500 font-semibold">
                      {f.time}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-sm text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors">
                        {f.headline}
                        {f.hot && (
                          <span className="inline-flex items-center gap-0.5 ml-2 text-xs font-bold text-primary-500 align-middle">
                            <i className="ri-fire-fill" />
                            热
                          </span>
                        )}
                      </span>
                    </span>
                    <span className="hidden md:inline-block shrink-0 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium px-2.5 py-1">
                      {f.source}
                    </span>
                    <span className="shrink-0 hidden sm:inline text-xs text-foreground-500">
                      #{f.tag}
                    </span>
                    <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 shrink-0" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 汇总侧栏：口径速览 */}
          <aside className="lg:col-span-4 pt-0 lg:pt-14">
            <div className="sticky top-24 rounded-xl bg-background-50 border border-background-200 p-4 md:p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950 mb-4">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary-500 text-background-50">
                  <i className="ri-file-list-3-line text-[13px]" />
                </span>
                今日口径速览
              </h3>
              <div className="space-y-3">
                <div>
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-foreground-700 font-medium">回应对照</span>
                    <span className="text-foreground-500">口径 3 版</span>
                  </div>
                  <div className="h-2 rounded-full bg-background-100 overflow-hidden">
                    <div className="h-full w-[78%] bg-primary-500 rounded-full" />
                  </div>
                </div>
                <div>
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-foreground-700 font-medium">路透线索</span>
                    <span className="text-foreground-500">已核实 9 处</span>
                  </div>
                  <div className="h-2 rounded-full bg-background-100 overflow-hidden">
                    <div className="h-full w-[62%] bg-accent-500 rounded-full" />
                  </div>
                </div>
                <div>
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-foreground-700 font-medium">待跟进词条</span>
                    <span className="text-foreground-500">24 条</span>
                  </div>
                  <div className="h-2 rounded-full bg-background-100 overflow-hidden">
                    <div className="h-full w-[44%] bg-secondary-400 rounded-full" />
                  </div>
                </div>
              </div>
              <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
                汇总页把同源瓜料按口径分组，避免来回跳转刷屏，进度更省心。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}